var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "premium-hint-container" },
    [
      _c("separator", { staticClass: "premium-hint-separator" }),
      _vm._v(" "),
      _c("div", { staticClass: "premium-hint" }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("redeem")]),
        _vm._v(" "),
        _c("p", { staticClass: "premium-hint__text" }, [
          _vm._v(_vm._s(_vm.$t("PREMIUM_HINT.TEXT")))
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }